// SYNC taxticbackend\src\utils\brandTokens.js
// Cualquier cambio se replica manualmente en ambos archivos.

export const BRAND = {
  color: {
    primary: "#d57a23", // Pantone 158 C
    primaryDark: "#b56720",
    primaryTint: "#fff0e0", // fondo suave para chips y highlights sobre primary
    primaryBg: "#FFF3E0",
    primaryHoverBg: "#FFE0B2",

    ink: "#000000",
    inkSoft: "#1a1a1a",
    paper: "#FFFFFF",
    grey90: "#1a1a1a",
    grey70: "#4a4a4a",
    grey50: "#888888",
    grey30: "#cccccc",
    grey10: "#f0f0f0",
    divider: "#e5e5e5",
    dividerDark: "#333333",
  },
  font: {
    family: {
      base: "'Inter', 'Helvetica Neue', Arial, sans-serif",
      display: "'Inter', 'Helvetica Neue', Arial, sans-serif",
      // Future: display: "'Prototype', 'Inter', sans-serif"
    },
    weight: { light: 300, regular: 400, medium: 500, bold: 700, black: 800 },
    size: {
      eyebrow: "9pt",
      bodySmall: "9.5pt",
      body: "10.5pt",
      bodyLarge: "12pt",
      h3: "14pt",
      h2: "20pt",
      h1: "32pt",
      hero: "48pt",
    },
    lineHeight: { tight: 1.05, snug: 1.3, body: 1.65, loose: 1.85 },
    letterSpacing: { tight: "-0.5px", normal: "0", wide: "1px", widest: "2px" },
  },
  space: { xs: 4, sm: 8, md: 16, lg: 24, xl: 32, xxl: 48, hero: 80 },
  radius: { none: 0, xs: 2, sm: 4 },
  page: {
    sizeA4: "A4",
    margin: "20mm 22mm",
    headerH: "12mm",
    footerH: "10mm",
  },
};
